import { Layout } from '../components/layout/Layout';
import { ContentSection, SectionHeader } from '../components/sections/ContentSection';
import { PhotoGallery } from '../components/gallery/PhotoGallery';
import { usePublicData } from '../hooks/usePublicData';
import { SEO } from '../components/SEO';
import { Loader2 } from 'lucide-react';

export default function Gallery() {
  const { data: gallery, loading } = usePublicData('gallery');

  // Transform gallery for PhotoGallery component
  const displayGallery = gallery.map(item => ({
    url: item.imageUrl,
    alt: item.title,
    caption: item.caption || item.title
  }));

  return (
    <Layout>
      <SEO 
        title="Photo Gallery"
        description="View photos from Geneva United Methodist Church - worship services, community events, and church family moments."
        url="/gallery"
      />
      
      {/* Hero Banner */}
      <section className="relative h-[40vh] min-h-[300px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://customer-assets.emergentagent.com/job_geneva-faith-site/artifacts/uw8747ga_Church-sanctuary-people.jpg"
            alt="Geneva UMC congregation"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 hero-overlay" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4" data-testid="gallery-page-title">
            Photo Gallery
          </h1>
          <p className="text-xl text-slate-200 max-w-2xl mx-auto">
            Moments and memories from our church family
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <ContentSection bgColor="bg-white">
        <SectionHeader 
          title="Life at Geneva UMC"
          subtitle="Click on any image to view it in full size"
        />
        {loading ? (
          <div className="flex justify-center py-12">
            <Loader2 className="w-8 h-8 animate-spin text-secondary" />
          </div>
        ) : displayGallery.length > 0 ? (
          <PhotoGallery images={displayGallery} columns={3} />
        ) : (
          <div className="text-center py-12 bg-slate-50 rounded-xl">
            <p className="text-slate-500">Gallery coming soon.</p>
            <p className="text-slate-400 text-sm mt-2">Check back for photos of our church family!</p>
          </div>
        )}
      </ContentSection>

      {/* Photo Submission CTA */}
      <ContentSection bgColor="bg-slate-50" paddingY="py-12">
        <div className="text-center">
          <p className="text-slate-600">
            Have photos from a church event you'd like to share? 
            <a href="/contact" className="text-secondary font-semibold hover:underline ml-1" data-testid="gallery-share-link">
              Contact us
            </a>
            {" "}to submit them for our gallery.
          </p>
        </div>
      </ContentSection>
    </Layout>
  );
}
